import React from "react";

function RepeatOrder() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 510.7 510.7"
    >
      <path
        fill="#b7d341"
        d="M510.7 209.53l-56.83 67.09-67.24-58.28 19.64-22.67 27.22 23.59C416.41 124.29 333.16 52 233.35 52 121.22 52 30 143.22 30 255.35S121.22 458.7 233.35 458.7v30c-62.33 0-120.93-24.27-165-68.35C24.27 376.28 0 317.68 0 255.35s24.27-120.93 68.35-165C112.42 46.27 171.02 22 233.35 22s120.93 24.27 165 68.35c35.26 35.25 57.83 79.81 65.46 128.13l23.99-28.34z"
        data-original="#80aaff"
      ></path>
      <path
        fill="#ffd396"
        d="M233.35 170.63l24.29 91.87-24.29 94.66H128.71v-208.8h80.36z"
        data-original="#ffd396"
      ></path>
      <path
        fill="#ffbf80"
        d="M337.99 148.36v208.8H233.35V170.63l24.29-22.27z"
        data-original="#ffbf80"
      ></path>
      <path
        fill="#ca6d36"
        d="M233.35 148.36l14.61 30.14-14.61 24.94-24.28 13.37v-68.45z"
        data-original="#ca6d36"
      ></path>
      <path
        fill="#b34f03"
        d="M257.64 148.36v68.45l-24.29-13.37v-55.08z"
        data-original="#b34f03"
      ></path>
    </svg>
  );
}

export default RepeatOrder;
